import {
    flagStrip
} from "../styles/ChallanStyles";
export const FlagStrip = ({ flag }) => {
    const s = flagStrip(flag.type === "danger");
    return (
        <div style={s.wrapper}>
            <div style={s.dot} />
            <div
                style={s.text}
                dangerouslySetInnerHTML={{
                    __html: flag.text.replace(/^(.*?:)/, "<strong>$1</strong>"),
                }}
            />
        </div>
    );
};